<template>
  <div class="userinfo">
    <div class="cjh-title" v-if="!isDis">
      <div>个人信息</div>
     <el-button
        type="primary"
        class="status"
        @click="shVisible = true"
         v-if="ruleForm.is_submit == 3 || ruleForm.is_submit == 4"
      >
        审核状态
      </el-button>
    </div>
    <div class="cjh-cnt">
      <el-form
        ref="form"
        :model="ruleForm"
        :disabled="isDis || noEdit"
        :rules="rules"
        label-width="150px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="证件照片" prop="fileList" :rules="btRules">
              <template v-if="!isDis && !noEdit">
                <el-upload
                  ref="elUpload"
                  list-type="picture-card"
                  action
                  :limit="1"
                  :auto-upload="false"
                  :on-remove="handleRemove"
                  :on-change="handleChange"
                  :on-exceed="onExceed"
                  :file-list="ruleForm.fileList"
                  :on-preview="handlePictureCardPreview"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="tip">
                  请上传小2寸免冠照片（jpg,png格式，不超过2M）
                </div>
              </template>

              <el-image
                v-if="isDis || noEdit"
                style="width: 100px; height: 100px"
                :src="ruleForm.fileList"
                :preview-src-list="ruleForm.fileList"
              >
              </el-image>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="user_name" :rules="btRules">
              <el-input
                v-model="ruleForm.user_name"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="证件类型"
              prop="document_type"
              :rules="btRules"
            >
              <el-select
                v-model="ruleForm.document_type"
                placeholder="请选择"
                style="width: 100%"
                filterable
                clearable
              >
                <el-option
                  :label="item"
                  :value="item"
                  v-for="(item, index) in zjlx"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="证件号码"
              prop="identification_number"
              :rules="btRules"
            >
              <el-input
                v-model="ruleForm.identification_number"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex" :rules="btRules">
              <el-radio-group v-model="ruleForm.sex">
                <el-radio label="0">男</el-radio>
                <el-radio label="1">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="出生日期" prop="birth_date" :rules="btRules">
              <el-date-picker
                v-model="ruleForm.birth_date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                type="date"
                placeholder="选择日期"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="民族" prop="nation" :rules="btRules">
              <el-select
                v-model="ruleForm.nation"
                placeholder="请选择"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  :label="item"
                  :value="item"
                  v-for="(item, index) in mz"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="籍贯" prop="native_place" :rules="btRules">
              <el-cascader
                filterable
                v-model="ruleForm.native_place"
                :options="jgList"
                style="width: 100%"
                clearable
                :props="{ label: 'name', value: 'name' }"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="政治面貌"
              prop="political_outlook"
              :rules="btRules"
            >
              <el-select
                v-model="ruleForm.political_outlook"
                placeholder="请选择"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  :label="item"
                  :value="item"
                  v-for="(item, index) in zzmmList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="最高学历"
              prop="highest_education_level"
              :rules="btRules"
            >
              <el-select
                v-model="ruleForm.highest_education_level"
                placeholder="请选择"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  :label="item"
                  :value="item"
                  v-for="(item, index) in zgxlList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="最高学位"
              prop="highest_degree"
              :rules="btRules"
            >
              <el-select
                v-model="ruleForm.highest_degree"
                placeholder="请选择"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  :label="item"
                  :value="item"
                  v-for="(item, index) in zgxwList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="毕业院校"
              prop="university_one_is_graduated"
              :rules="btRules"
            >
              <el-input
                v-model="ruleForm.university_one_is_graduated"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="所学专业"
              prop="major_studied"
              :rules="btRules"
            >
              <el-input
                v-model="ruleForm.major_studied"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="本人手机" prop="mobile" :rules="btRules">
              <el-input
                v-model="ruleForm.mobile"
                placeholder="请输入"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电子邮箱" prop="mailbox">
              <el-input
                v-model="ruleForm.mailbox"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="现工作单位" prop="work_unit" :rules="btRules">
              <el-input
                v-model="ruleForm.work_unit"
                placeholder="请输入人事关系所在单位"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="工作部门"
              prop="work_department"
              :rules="btRules"
            >
              <el-input
                v-model="ruleForm.work_department"
                placeholder="属于内设机构的应填写具体部门。没有请填“无”"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="行政职务"
              prop="administrative_position"
              :rules="btRules"
            >
              <el-input
                v-model="ruleForm.administrative_position"
                placeholder="没有请填无"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="专业技术职称"
              prop="professional_technical"
              :rules="btRules"
            >
              <el-cascader
                filterable
                v-model="ruleForm.professional_technical"
                :options="zyjszcList"
                style="width: 100%"
                clearable
                :props="{ label: 'positionName', value: 'positionName' }"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="单位性质" prop="unit_nature" :rules="btRules">
              <el-radio-group v-model="ruleForm.unit_nature">
                <el-radio label="党政机关">党政机关</el-radio>
                <el-radio label="高等院校">高等院校</el-radio>
                <el-radio label="科研院所">科研院所</el-radio>
                <el-radio label="国有企业">国有企业</el-radio>
                <el-radio label="民营企业">民营企业</el-radio>
                <el-radio label="外资企业">外资企业</el-radio>
                <el-radio label="军队系统">军队系统</el-radio>
                <el-radio label="事业单位">事业单位</el-radio>
                <el-radio label="其他">其他</el-radio>
              </el-radio-group>
              <div class="tip">
                请您正确填写单位性质。例如：企业下属科研院所，单位性质应选择对应企业。
              </div>
              <el-input
                v-if="ruleForm.unit_nature === '其他'"
                v-model="ruleForm.unit_nature_other"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="单位通信地址"
              prop="unit_communication_address"
              :rules="btRules"
            >
              <el-cascader
                filterable
                v-model="ruleForm.unit_communication_address"
                :options="jgList"
                style="width: 100%"
                clearable
                :props="{ label: 'name', value: 'name' }"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-input
              v-model="ruleForm.unit_detailed_address"
              placeholder="请输入详细地址"
              clearable
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="本人银行卡号" prop="my_bank_card_number">
              <el-input
                v-model="ruleForm.my_bank_card_number"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行" prop="opening_bank">
              <el-input
                v-model="ruleForm.opening_bank"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位联系人" prop="unit_contact_person">
              <el-input
                v-model="ruleForm.unit_contact_person"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人手机" prop="cell_Phone">
              <el-input
                v-model="ruleForm.cell_Phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="邮政编码" prop="postal_code" :rules="btRules">
              <el-input
                v-model="ruleForm.postal_code"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="四个方向" prop="four_directions">
              <el-select
                style="width: 100%"
                v-model="ruleForm.four_directions"
                multiple
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in zgfx"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="学术荣誉" prop="academic_honors">
              <el-checkbox-group v-model="ruleForm.academic_honors">
                <el-checkbox
                  :label="item"
                  v-for="(item, index) in xsry"
                  :key="index"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
              <!-- <el-select
                style="width: 100%"
                v-model="ruleForm.academic_honors"
                multiple
                filterable
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in xsry"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="曾担任评委" prop="serve_judge">
              <el-checkbox-group v-model="ruleForm.serve_judge">
                <el-checkbox
                  :label="item"
                  v-for="(item, index) in drpwList"
                  :key="index"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
              <el-input
                v-if="ruleForm.serve_judge.includes('其他')"
                placeholder="请输入"
                v-model="ruleForm.serve_judge_other"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="行业领域"
              prop="industry_field"
              :rules="btRules"
            >
              <el-checkbox-group v-model="ruleForm.industry_field">
                <el-checkbox
                  :label="item"
                  v-for="(item, index) in hyly"
                  :key="index"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
              <el-input
                v-if="ruleForm.industry_field.includes('其他')"
                placeholder="请输入"
                v-model="ruleForm.industry_field_other"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="学科方向"
              prop="subject_direction"
              :rules="btRules"
            >
              <el-input
                v-model="ruleForm.subject_direction"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关键词" prop="key_word">
              <el-input
                v-model="ruleForm.key_word"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="产学研相关需求和意见"
              prop="industry_university_research"
            >
              <el-input
                type="textarea"
                placeholder="请输入"
                v-model="ruleForm.industry_university_research"
                :autosize="{ minRows: 4 }"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="人大代表" prop="deputies">
              <el-checkbox-group v-model="ruleForm.deputies">
                <el-checkbox
                  :label="item"
                  v-for="(item, index) in rddbList"
                  :key="index"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
              <el-input
                v-if="ruleForm.deputies.includes('地方人大代表')"
                placeholder="请输入"
                v-model="ruleForm.deputies_other"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="政协委员" prop="zx_member">
              <el-checkbox-group v-model="ruleForm.zx_member">
                <el-checkbox
                  :label="item"
                  v-for="(item, index) in zxwyList"
                  :key="index"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
              <el-input
                v-if="ruleForm.zx_member.includes('地方政协委员')"
                placeholder="请输入"
                v-model="ruleForm.zx_member_other"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </div>
    <div class="btn-warp" v-if="!isDis && !noEdit">
      <el-button type="primary" plain class="btn" @click="handleSaveZc"
        >暂存数据</el-button
      >
      <el-button type="primary" class="btn" @click="handleSave">保存</el-button>
    </div>
    <el-dialog
      title="审核状态"
      :visible.sync="shVisible"
      width="30%"
      :before-close="handleClose"
      v-if="shVisible"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <!-- 已通过 -->
        <template v-if="ruleForm.is_submit == 4">
          <el-form-item label="审核状态" prop="examine_remark">
            <el-input value="已通过" disabled></el-input>
          </el-form-item>
          <el-form-item label="证书编号" prop="examine_number">
            <el-input
              v-model="ruleForm.examine_number"
              type="textarea"
              disabled
            ></el-input>
          </el-form-item>
          <!--<el-form-item
            label="证书有效期"
            prop="examine_certificate_validity_period"
          >
            <el-date-picker
              v-model="ruleForm.examine_certificate_validity_period"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              disabled
            >
            </el-date-picker>
          </el-form-item>-->
          <el-form-item
            label="证书附件"
            prop="examine_certificate_validity_period"
          >
            <el-button
              type="primary"
              v-if="ruleForm.certificate_url"
              @click="handlePreview"
            >
              预览
            </el-button>
            <div v-else>无证书附件</div>
          </el-form-item>
        </template>
        <template v-if="ruleForm.is_submit == 3">
          <el-form-item label="审核状态">
            <el-input value="已驳回" disabled></el-input>
          </el-form-item>
          <el-form-item label="驳回原因" prop="reject_message">
            <el-input
              v-model="ruleForm.reject_message"
              placeholder="请输入"
              type="textarea"
              disabled
            ></el-input>
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  update_data,
  getUserInfo,
  upload_file,
  index_class,
  update_user_data
} from '../../axios/api'
import area from './json/area.json'
import technical from './json/technical.json'
import { setPrefix } from '../../utils/tool'
export default {
  props: {
    isDis: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      ruleForm: {
        fileList: [],
        four_directions: [],
        academic_honors: [],
        serve_judge: [],
        industry_field: [],
        deputies: [],
        zx_member: [],
        sex: 0,
        user_name: ''
      },
      btRules: [
        { required: true, message: '必填', trigger: ['blur', 'change'] }
      ],
      zjlx: [
        '居民身份证',
        '台湾居民来往大陆通行证',
        '港澳居民来往内地通行证',
        '中华人民共和国港澳居民居住证',
        '中华人民共和国台湾居民居住证',
        '中国护照',
        '外国人永久居住身份证',
        '香港居民身份证',
        '澳门居民身份证',
        '台湾居民身份证',
        '其他证件类型'
      ],
      mz: [
        '汉族',
        '满族',
        '蒙古族',
        '回族',
        '藏族',
        '维吾尔族',
        '苗族',
        '彝族',
        '壮族',
        '布依族',
        '侗族',
        '瑶族',
        '白族',
        '土家族',
        '哈尼族',
        '哈萨克族',
        '傣族',
        '黎族',
        '傈僳族',
        '佤族',
        '畲族',
        '高山族',
        '拉祜族',
        '水族',
        '东乡族',
        '纳西族',
        '景颇族',
        '柯尔克孜族',
        '土族',
        '达斡尔族',
        '仫佬族',
        '羌族',
        '布朗族',
        '撒拉族',
        '毛南族',
        '仡佬族',
        '锡伯族',
        '阿昌族',
        '普米族',
        '朝鲜族',
        '塔吉克族',
        '怒族',
        '乌孜别克族',
        '俄罗斯族',
        '鄂温克族',
        '德昂族',
        '保安族',
        '裕固族',
        '京族',
        '塔塔尔族',
        '独龙族',
        '鄂伦春族',
        '赫哲族',
        '门巴族',
        '珞巴族',
        '基诺族'
      ],
      jgList: area,
      zzmmList: [
        '中共党员',
        '中共预备党员',
        '共青团员',
        '民革会员',
        '民盟盟员',
        '民建会员',
        '民进会员',
        '农工党党员',
        '致公党党员',
        '九三学社社员',
        '台盟盟员',
        '无党派人士',
        '群众'
      ],
      zgxlList: ['研究生', '本科', '专科', '其他'],
      zgxwList: ['博士', '硕士', '学士', '无'],
      rddbList: ['全国人大代表', '地方人大代表'],
      zxwyList: ['全国政协委员', '地方政协委员'],
      zyjszcList: technical,
      hyly: [],
      drpwList: [],
      xsry: [
        '两院院士',
        '领军人才',
        '长江学者',
        '国家杰出青年',
        '国家“万人计划”',
        '国家奖获奖者(前三完成人)'
      ],
      zgfx: [
        '面向世界科技前沿',
        '面向经济主战场',
        '面向国家重大需求',
        '面向人民生命健康'
      ],
      rules: {
        mailbox: [
          {
            required: true,
            message: '必填',
            trigger: ['blur', 'change']
          },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ],
        mobile: [
          {
            required: true,
            message: '必填',
            trigger: ['blur', 'change']
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的电话号码',
            trigger: 'blur'
          }
        ],
        cell_Phone: [
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的电话号码',
            trigger: 'blur'
          }
        ]
      },
      files: null,
      dialogImageUrl: '',
      dialogVisible: false,
      shVisible: false,
      ruleForm2: {},
      noEdit: false
    }
  },
  mounted () {
    index_class({ token: sessionStorage.getItem('Token3') }).then((res) => {
      if (res.data.code === 200) {
        const dictObj = res.data.data.types || {}
        this.hyly = dictObj[11].map((item) => item.name)
        this.drpwList = dictObj[10].map((item) => item.name)
      }
    })
    if (this.isDis) {
      this.ruleForm = sessionStorage.getItem('cjhuser')
        ? JSON.parse(sessionStorage.getItem('cjhuser'))
        : {}
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    } else {
      this.ruleForm = sessionStorage.getItem('uinfo')
        ? JSON.parse(sessionStorage.getItem('uinfo'))
        : {}
      if (this.ruleForm.is_submit == 1 || this.ruleForm.is_submit == 4) {
        // 已提交就不可编辑，已审核也不可再编辑, 只有未提交和驳回才可编辑
        this.noEdit = true
      }
      if (this.ruleForm.is_submit == 3 || this.ruleForm.is_submit == 4) { // 驳回和审核通过都需要弹窗
        const isAlert = sessionStorage.getItem('ualert') === 'alert'
        if (isAlert) {
          this.shVisible = true
          sessionStorage.setItem('ualert', '')
        }
      }
    }

    this.ruleForm.four_directions = this.ruleForm.four_directions?.length
      ? JSON.parse(this.ruleForm.four_directions)
      : []
    this.ruleForm.academic_honors = this.ruleForm.academic_honors?.length
      ? JSON.parse(this.ruleForm.academic_honors)
      : []
    this.ruleForm.serve_judge = this.ruleForm.serve_judge?.length
      ? JSON.parse(this.ruleForm.serve_judge)
      : []
    const zx_member = this.ruleForm.zx_member?.length
      ? JSON.parse(this.ruleForm.zx_member)
      : []
    this.$set(this.ruleForm, 'zx_member', zx_member)
    const deputies = this.ruleForm.deputies?.length
      ? JSON.parse(this.ruleForm.deputies)
      : []
    this.$set(this.ruleForm, 'deputies', deputies)
    this.ruleForm.industry_field = this.ruleForm.industry_field?.length
      ? JSON.parse(this.ruleForm.industry_field)
      : []
    this.ruleForm.native_place = this.ruleForm.native_place?.length
      ? JSON.parse(this.ruleForm.native_place)
      : []
    this.ruleForm.unit_communication_address = this.ruleForm
      .unit_communication_address?.length
      ? JSON.parse(this.ruleForm.unit_communication_address)
      : []
    this.ruleForm.professional_technical = this.ruleForm.professional_technical
      ?.length
      ? JSON.parse(this.ruleForm.professional_technical)
      : []
    if (this.ruleForm.id_photo) {
      this.$set(this.ruleForm, 'fileList', [
        { url: setPrefix(this.ruleForm.id_photo) }
      ])
    }
  },
  methods: {
    handleClose () {
      this.shVisible = false
    },
    handlePreview () {
      const url = setPrefix(this.ruleForm.certificate_url)
      window.open(url)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove (file, fileList) {
      if (!fileList.length) {
        this.files = null
      }

      this.$set(this.ruleForm, 'fileList', [...fileList])
    },
    handleChange (file, fileList) {
      const MAX_SIZE = 1024 * 1024 * 2 // 设置最大为10KB
      if (file.size > MAX_SIZE) {
        this.$message({
          message: '文件大小不能超过2MB',
          type: 'info'
        })
        this.$set(this.ruleForm, 'fileList', [])
        // 处理文件过大的情况，比如清除文件或者禁用上传按钮
        return false
      }
      const hzm = file.name.split('.')
      const hzname = hzm.length ? hzm[hzm.length - 1] : ''
      if (!['png', 'jpg'].includes(hzname.toLocaleLowerCase())) {
        this.$message({
          message: '请上传jpg，png格式的图片',
          type: 'info'
        })
        this.$set(this.ruleForm, 'fileList', [])
        // 处理文件过大的情况，比如清除文件或者禁用上传按钮
        return false
      }
      this.$set(this.ruleForm, 'fileList', fileList)
      this.files = file?.raw // 把文件赋值给变量
    },
    onExceed () {
      this.$message({
        message: '只能上传一张图片',
        type: 'info'
      })
    },
    saveFun () {
      const save = () => {
        const params = {
          ...this.ruleForm,
          token: sessionStorage.getItem('Token3')
        }
        params.four_directions = params.four_directions
          ? JSON.stringify(params.four_directions)
          : ''
        params.academic_honors = params.academic_honors
          ? JSON.stringify(params.academic_honors)
          : ''
        params.serve_judge = params.serve_judge
          ? JSON.stringify(params.serve_judge)
          : ''
        params.zx_member = params.zx_member
          ? JSON.stringify(params.zx_member)
          : ''
        params.deputies = params.deputies
          ? JSON.stringify(params.deputies)
          : ''
        params.industry_field = params.industry_field
          ? JSON.stringify(params.industry_field)
          : ''
        params.native_place = params.native_place
          ? JSON.stringify(params.native_place)
          : ''
        params.unit_communication_address = params.unit_communication_address
          ? JSON.stringify(params.unit_communication_address)
          : ''
        params.professional_technical = params.professional_technical
          ? JSON.stringify(params.professional_technical)
          : ''
        delete params.fileList
        update_data({ ...params }).then((ress) => {
          if (ress.data.code === 200) {
            getUserInfo({ token: sessionStorage.getItem('Token3') }).then(
              (res) => {
                if (res.data.code === 200) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                  sessionStorage.setItem(
                    'uinfo',
                    JSON.stringify(res.data.data)
                  )
                }
              }
            )
          }
        })
      }
      if (this.files) {
        const form = new FormData()
        form.append('file', this.files)
        form.append('token', sessionStorage.getItem('Token3'))
        upload_file(form).then((res) => {
          // 上传文件的接口url
          if (res.data.code === 200) {
            this.ruleForm.id_photo = res.data.url
            save()
          }
        })
      } else {
        save()
      }
    },
    handleSaveZc () {
      this.saveFun()
    },
    handleSave () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveFun()
        } else {
          console.log('error submit!!')
          this.$message({
            message: '请填写完必填项',
            type: 'error'
          })
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.userinfo {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  .cjh-cnt {
    flex: 1;
    overflow-y: auto;
    padding: 20px 25px;
  }
  .cjh-title {
    padding: 20px 25px;
    border-bottom: 1px solid rgba(220, 220, 220, 0.5);
    font-weight: 600;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    .status {
      cursor: pointer;
    }
  }
  .btn-warp {
    background: #fff;
    padding: 30px 50px;
    left: 0;
    bottom: 0;
    .btn {
      height: 42px;
    }
  }
}
.tip {
  color: #999;
}
</style>
